import React from 'react'
import { Avatar as AntAvatar } from 'antd'
import { AvatarProps as AntAvatarProps } from 'antd/lib/avatar'

interface SelfProps extends AntAvatarProps {
  nameChar?: string
  showBorderColor?: true
  showOutline?: boolean
}

type Props = SelfProps

const COLOR_LIST = [
  { color: '--color-blue-500', key: 'a' },
  { color: '--color-blue-400', key: 'b' },
  { color: '--color-yellow-400', key: 'c' },
  { color: '--color-yellow-400', key: 'd' },
  { color: '--color-purple-400', key: 'e' },
  { color: '--color-purple-400', key: 'f' },
  { color: '--color-orange-400', key: 'g' },
  { color: '--color-orange-400', key: 'h' },
  { color: '--color-cyan-400', key: 'i' },
  { color: '--color-cyan-400', key: 'j' },
  { color: '--color-magenta-400', key: 'k' },
  { color: '--color-magenta-400', key: 'l' },
  { color: '--color-green-400', key: 'm' },
  { color: '--color-green-400', key: 'n' },
  { color: '--color-gray-400', key: 'o' },
  { color: '--color-gray-400', key: 'p' },
  { color: '--color-blue-500', key: 'q' },
  { color: '--color-yellow-500', key: 'r' },
  { color: '--color-purple-500', key: 's' },
  { color: '--color-orange-500', key: 't' },
  { color: '--color-cyan-500', key: 'u' },
  { color: '--color-magenta-500', key: 'v' },
  { color: '--color-magenta-500', key: 'w' },
  { color: '--color-gray-500', key: 'x' },
  { color: '--color-green-500', key: 'y' },
  { color: '--color-green-500', key: 'z' }
]

export const Avatar: React.FC<Props> = ({
  children,
  className,
  shape,
  src,
  alt,
  icon,
  size,
  nameChar,
  showBorderColor,
  showOutline
}) => {
  const getColor = () => {
    if (nameChar && !icon) {
      const casedName = nameChar?.toLowerCase()?.[0]
      const colorSet = COLOR_LIST.find(item => item.key === casedName)
      if (colorSet) {
        let style: {
          backgroundColor: string
          border?: string
          boxShadow?: string
        } = {
          backgroundColor: `var(${colorSet.color})`
        }
        if (showBorderColor) {
          style = {
            ...style,
            border: `2px solid var(${colorSet.color})`
          }
        }
        if (showOutline) {
          style = {
            ...style,
            boxShadow: `0 0 0 1px white`
          }
        }
        return style
      } else {
        return {
          backgroundColor: `var(--color-gray-400)`
        }
      }
    }
  }
  return (
    <AntAvatar
      src={src}
      shape={shape}
      className={className}
      alt={alt}
      icon={icon}
      size={size}
      style={getColor()}
    >
      {children}
    </AntAvatar>
  )
}
